import { useQuery } from "@tanstack/react-query";
import { request } from "../../utilities/axios-utils.js";
import { Application } from "../../config/const/enums.js";
import useSharedData from "../useSharedData";

const MOCK_RESPONSE = {
  QT_ALL_COVERS_QUOTE: "qtAllCoversQuote",
  QT_LIFE_ONLY_COVER_QUOTE: "qtLifeOnlyCoverQuote",
  QT_LIFE_AND_CI_COVER_QUOTE: "qtLifeAndCICoverQuote",
  NB_LIFE_AND_UPSELL: "nbLifeAndUpSell",
  NB_LIFE_AND_UPSELL_AND_PUW: "nbLifeAndUpSellAndPUW",
  NB_LIFE_EXCLUSIONS_AND_CI: "nbLifeExclusionsAndCI",
  NB_LIFE_CI_PUW_EXCLUSIONS: "nbLifeCAndPuwExclusions",
  NB_LIFE_ONLY: "nbLifeOnly",
  NB_LIFE_AND_PUW: "nbLifeAndPuw",
  NB_LIFE_AND_CI: "nbLifeAndCI",
  NB_LIFE_AND_PUW_DECLINE: "nbLifeAndPuwDeclined",
  NB_VALIDATION_FIX: "nbValidationFix",
};

//----------------------------------------------------------------

const retrieveQuoteDetails = async (
  retrieveQuoteDetailsPayload,
  isDevShared = false,
  setPdsUrl,
  setRetrievedCoverDetails
) => {
  try {
    //!----------------------------------------------------------------
    //* TODO: isDev PRE-DEPLOY
    const isDev = isDevShared;

    if (isDev === true && import.meta.env.MODE === "development") {
      import("../../data/mock/retrieve-nb-quote-response-mock-data.js")
        .then((module) => {
          const retrieveNBQuoteResponse = module.retrieveNBQuoteResponse;

          const mockResponse = retrieveNBQuoteResponse(
            MOCK_RESPONSE.NB_LIFE_AND_UPSELL
          );
          return mockResponse.data;
        })
        .catch((error) => {
          console.log("Error loading mock data: ", error);
        });
    }

    // if (isDev) {
    // 	// Get the mocked response data and map it
    // 	// const mockResponse = retrieveQuoteResponse(
    // 	// 	MOCK_RESPONSE.QT_ALL_COVERS_QUOTE
    // 	// );
    // 	const mockResponse = retrieveNBQuoteResponse(
    // 		MOCK_RESPONSE.NB_LIFE_AND_UPSELL
    // 	);
    // 	return mockResponse.data;
    // }
    //!----------------------------------------------------------------

    if (retrieveQuoteDetailsPayload?.oktaAccessToken) {
      const response = await request({
        url:
          retrieveQuoteDetailsPayload.application === Application.CONTACT_CENTER
            ? `/retrieveQuote/${retrieveQuoteDetailsPayload?.transactionUid}`
            : `/retrieveQuote`,
        method: "GET",
        accessToken: retrieveQuoteDetailsPayload.oktaAccessToken,
      });
      if (response?.data?.general?.pdsUrl) {
        await setPdsUrl(response.data.general.pdsUrl);
      }

      await setRetrievedCoverDetails(response.data);

      return response?.data ? response?.data : response;
    } else {
      return null;
    }
  } catch (error) {
    console.error("Error occurred while retrieve quote details :", error);
    return null;
  }
};

export const useGetRetrieveQuoteDetails = (
  retrieveQuoteDetailsPayload,
  isDevShared = false
) => {
  const { setPdsUrl, setRetrievedCoverDetails } = useSharedData();
  return useQuery({
    queryKey: [
      "getRetrieveQuoteDetails",
      retrieveQuoteDetailsPayload?.transactionUid,
    ],
    queryFn: async () =>
      await retrieveQuoteDetails(
        retrieveQuoteDetailsPayload,
        isDevShared,
        setPdsUrl,
        setRetrievedCoverDetails
      ),
    // enabled: false,
    refetchOnWindowFocus: false,
  });
};
